import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { AlertsTableComponent } from './table/table.component';
import { AlertsComponent } from './alerts.component';
import { EcaMonotronModule, EcaNoResultsModule, EcaSearchModule } from '@drc-eca/eca-components-lib';
import { AlertTypePipe } from './alert-type.pipe';
import { AlertsReviewComponent } from './review/review.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertsReviewTableComponent } from './review/table/table.component';
import { ImageViewerComponent } from './review/image/image-viewer.component';
import { ImageZoomComponent } from './review/image/zoom/zoom.component';
import { ConfirmClearAlertsDialogComponent } from './review/clear-dialog/confirm-clear-alerts-dialog.component';
import { ConfirmClearAlertsDialogService } from './review/clear-dialog/confirm-clear-alerts-dialog.service';
import { SubmitErrorComponent } from './review/submit-error/submit-error.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    EcaMonotronModule,
    EcaSearchModule,
    EcaNoResultsModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatButtonModule,
    MatTabsModule,
    MatFormFieldModule,
    MatCardModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule,
    AlertsTableComponent,
    AlertsComponent,
    AlertTypePipe,
    AlertsReviewComponent,
    AlertsReviewTableComponent,
    ImageViewerComponent,
    ImageZoomComponent,
    ConfirmClearAlertsDialogComponent,
    SubmitErrorComponent
  ],
  providers: [
    ConfirmClearAlertsDialogService,
  ],
  exports: [
    AlertsComponent,
  ]
})
export class AlertsModule {
}
